import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Helmet from "react-helmet";
import Button from "react-bootstrap";
import axios from "axios";
import http from "../services/httpService";
import { toast } from "react-toastify";
import { generatePath } from "react-router-dom";
import {
  getCitiesForState,
  getCustomersForAccountNumber,
  getTimeCodesForCityAndStateAndZip,
} from "../services/customerService";
import { apiUrl, basePath, tokenKeyName, defaultTitle } from "../config";
import { useHistory } from "react-router-dom";
import { DiliTextCP } from "./Utility/DiliTextCP";
import { isValidEmail, sortAccountLookupTimeCodes } from "../helpers/utilities";
import {
  getClientJWTInfo,
  getProfileInformation,
  isClient,
} from "../services/accountService";
import handleApiError from "../helpers/handleApiError";
import { getTimeCodeMeaning } from "../helpers/utilities";
import { useCallback, useMemo } from "react";
import { debounce } from "lodash";
import {
  getLabelsForMultipleDeliveries,
  postBuyout,
} from "../services/deliveryService";
import {
  clientsToBeExcludedFromPrintingLabels,
  customerSelectionTypes,
} from "../constants";
import jwtDecode from "jwt-decode";
import { AutoInitiatePrint } from "./Utility/AutoInitiatePrint";
import { postOrderLabelPrintMethods } from "../constants";
import fileDownload from "js-file-download";
import { NumberInput } from "./Utility/NumberInput";
import { ComboboxInfiniteLoading } from "./Utility/ComboboxInfiniteLoading";
import { LabelViewerModal } from "./Utility/LabelViewerModal";

const InvoiceTemplate = {
  invoiceNumber: "",
  isPurchasingInsurance: false,
  declaredValue: "",
};
const NewOrderCustomerDisplay = ({
  name,
  address,
  city,
  state,
  zip,
  email,
  phone,
}) => {
  return (
    <address
      className="text-left m-md-auto p-2"
      style={{ width: "fit-content" }}
    >
      <h4>{name}</h4>
      <p className="m-1">{address}</p>
      <p className="m-1">{city + ", " + state + " " + zip}</p>
      {/* don't get it from the back end right now but added it anyway. */}
      {phone && <p className="m-1">{phone}</p>}
      {/* Do not get these from backend right now, not even sure we really store it */}
      {/* <p className="m-1">
    {email} 
  </p>
  <p className="m-1">
    {phone}
  </p> */}
    </address>
  );
};
const PostNewBuyoutV2 = ({ loading, setLoading, jwtToken }) => {
  const history = useHistory();
  const [timeCode, setTimeCode] = useState("");
  const [customerSelectionType, setCustomerSelectionType] = useState(
    customerSelectionTypes.existing
  );
  const [cityAndState, setCityAndState] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerInfo, setCustomerInfo] = useState([]);

  const [customerAccountId, setCustomerAccountId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerCity, setCustomerCity] = useState("");
  const [customerZipCode, setCustomerZipCode] = useState("");
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [customerId, setCustomerId] = useState();
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [wasValue, setWasValue] = useState(0);
  const [emailAddress, setEmailAddress] = useState("");
  const [weight, setWeight] = useState("");
  const [pieceCount, setPieceCount] = useState("");
  const [startedTypingPC, setStartedTypingPC] = useState(false);
  const [contactPhone, setContactPhone] = useState("");
  const [accountNumberToLookup, setAccountNumberToLookup] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const handleChangeEmailAddress = (e) => {
    setEmailAddress(e.target.value);
  };

  const handleChangeZipCode = (e) => {
    setCustomerZipCode(e.target.value);
  };
  const handleChangePieceCount = (e) => {
    setPieceCount(e.target.value);
    if (startedTypingPC === false) {
      setStartedTypingPC(true);
    }
  };
  const handleChangePieceType = (e) => {
    setPieceType(e.target.value);
  };
  const handleChangeContactPhone = (e) => {
    setContactPhone(e.target.value);
  };
  const handleChangeAccountNumber = (e) => {
    setAccountNumberToLookup(e.target.value);
  };
  const handleChangeWeight = (e) => {
    setWeight(e.target.value);
  };
  const [callTag, setCallTag] = useState("");

  const handleChangeCallTag = (e) => {
    setCallTag(e.target.value);
  };
  const handleSetValue = (e) => {
    setCallTag(e.target.value);
  };
  const [existingSubmit, setExistingSubmit] = useState(false);
  const [lookupSubmit, setLookupSubmit] = useState(false);
  const [manualSubmit, setManualSubmit] = useState(false);

  const resetEverything = () => {
    setCustomerName("");
    setCustomerAddress("");
    setCustomerCity("");
    setCustomerZipCode("");
    setCustomerPhoneNumber("");
    setCustomerId();
    setWasSubmitted(false);
    setWasValue(0);
    setTimeCode("");
    setTimeCodes([]);
    // setEmailAddress("");
    setWeight("");
    setPieceCount("");
    setPieceType("");
    setStartedTypingPC(false);
    setContactPhone("");
    setAccountNumberToLookup("");
    setFoundAccountCustomer(null);
    setManualCity("");
    setManualState("");
    setCallTag("");
    setContactName("");
    setComments("");

    setCityAndState("");
    setCustomer("");
    setCustomerIndex();
    setCustomerInfo([]);

    setExistingSubmit(false);
    setLookupSubmit(false);
    setManualSubmit(false);
  };
  const [labelSrc, setLabelSrc] = useState();

  //===Label Modal to replace Popup ===//
  const [labelViewerModalData, setLabelViewerModalData] = useState({
    show: false,
    deliveryId: null,
  });
  const handleShowLabelViewerModal = (deliveryId) => {
    setLabelViewerModalData({
      show: true,
      deliveryId: deliveryId,
    });
  };
  const handleHideLabelViewerModal = () => {
    setLabelViewerModalData((prev) => {
      return { ...prev, show: false }; // leave the old delivery id to avoid the labelviewer component from trying refetch the label with null passed in
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    setWasSubmitted(true);
    setWasValue(1);

    if (
      customerSelectionType === customerSelectionTypes.existing &&
      (customerId === null || customerId === undefined)
    ) {
      toast.error("Please select a customer.");
      return;
    }

    const orderRequestBase = {
      pieceCount: pieceCount,
      timeCode: timeCode,
      weight: weight,
      customerAccountId: accountNumberToLookup,
      pieceType: pieceType,
      callTag: callTag,
      comment: comments,
      customerPhoneNumber: customerPhoneNumber,
      contactName: contactName,
      customerName: customerName,
      customerStateAbbreviation: customerState.toString(),
      contactPhone: contactPhone,
      emailAddress: emailAddress,
      customerAddress: customerAddress,
      customerCity: customerCity.toString(),
      customerZipCode: customerZipCode,
    };
    //console.log(orderRequestBase);
    if (customerSelectionType === customerSelectionTypes.existing) {
      setExistingSubmit(true);
      orderRequestBase.customerId = customerId;
    } else if (customerSelectionType === customerSelectionTypes.account) {
      setLookupSubmit(true);
      orderRequestBase.customerAccountId =
        foundAccountCustomer.customerAccountId;
      // const manualCustomerBase = {
      //   customerName: customerName,
      //   customerAddress: customerAddress,
      //   customerCity: customerCity,
      //   // customerStateAbbreviation:
      //   //   manualCustomerFormValues.customerStateAbbreviation,
      //   customerZipCode: customerZipCode,
      //   customerPhoneNumber: customerPhoneNumber,
      // };
      // orderRequest = { ...orderRequestBase, ...manualCustomerBase };
    } else {
      //for manual submission overwrite city and customerStateAbbreviation
      //with manualCity and manualState
      orderRequestBase.customerCity = manualCity;
      orderRequestBase.customerStateAbbreviation = manualState;
      setManualSubmit(true);
      setCustomerCity(manualCity); //?
      setCustomerState(manualState); //?
      //we already assign the manual entry fields when we initialize orderRequestBase
      // const normalCustomerBase = {
      //   customerId: customerId,
      // };
      // orderRequest = { ...orderRequestBase, ...normalCustomerBase };
    }

    setWasSubmitted(true);
    try {
      // console.log(orderRequestBase);
      setLoading(true);
      const { data: response } = await postBuyout(orderRequestBase);
      toast.success("Buyout has been posted.");
      const deliveryId = response.deliveryId;

      //if clients are not excluded from labels, show them the label viewer.
      //TODO: Change to the option they have selected in their account settings.
      // console.log(getClientJWTInfo().ClientId);

      if (
        !clientsToBeExcludedFromPrintingLabels.includes(
          getClientJWTInfo().ClientId
        )
      ) {
        // const redirectUrl = generatePath(`${basePath}/view-labels/:id`, {
        //   id: response.deliveryId,
        // });
        // window.open(redirectUrl, "_blank");

        //handle label print method
        let postOrderLabelPrintMethod = localStorage.getItem(
          "postOrderLabelPrintMethod"
        );
        // console.log(postOrderLabelPrintMethod);
        if (
          postOrderLabelPrintMethod === postOrderLabelPrintMethods.directToPrint
        ) {
          const { data: labelsPDF } = await getLabelsForMultipleDeliveries(
            "" + deliveryId,
            false,
            isClient()
          );
          const labelDataURL = window.URL.createObjectURL(labelsPDF);
          setLabelSrc(labelDataURL);
        } else if (
          postOrderLabelPrintMethod === postOrderLabelPrintMethods.download
        ) {
          const { data: labelsPDF } = await getLabelsForMultipleDeliveries(
            "" + deliveryId,
            false,
            isClient()
          );
          fileDownload(labelsPDF, `Diligent Label-${deliveryId}.pdf`);
        } else if (
          postOrderLabelPrintMethod === postOrderLabelPrintMethods.newTab
        ) {
          window.open(
            `${basePath}/view-labels/${deliveryId}`,
            "_blank",
            "noopener"
          );
        } else if (
          postOrderLabelPrintMethod === postOrderLabelPrintMethods.popup
        ) {
          window.open(
            `${basePath}/view-labels/${deliveryId}`,
            "_blank",
            "noopener popup,width=750,height=900"
          );
        } else {
          //Defaults to modal.
          handleShowLabelViewerModal(deliveryId);
        }
      }
      resetEverything();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      handleApiError(ex, history);
    }
  };
  const handleOnInvalid = async (e) => {
    setWasSubmitted(true);
    if (customerSelectionType == customerSelectionTypes.existing) {
      setExistingSubmit(true);
    }
    if (customerSelectionType == customerSelectionTypes.account) {
      setLookupSubmit(true);
    }
    if (customerSelectionType == customerSelectionTypes.new) {
      setManualSubmit(true);
    }
  };
  const handleClickFindAccount = async () => {
    if (!accountNumberToLookup) {
      toast.error("Please enter an account number for lookup.");
      return;
    }
    setTimeCodes([]);
    setTimeCode("");
    setFoundAccountCustomer(null);

    try {
      setLoading(true);
      setShowAccountNotFoundHelperText(false);
      const { data: foundCustomer } = await getCustomersForAccountNumber(
        accountNumberToLookup
      );
      // setCustomerAccountId(foundCustomer.customerAccountId);
      setFoundAccountCustomer(foundCustomer);
      // console.log(foundCustomer);
      const sortedTimeCodes = sortAccountLookupTimeCodes(
        foundCustomer.timeCodes ?? []
      );
      setTimeCodes(sortedTimeCodes);
      setTimeCode(sortedTimeCodes[0] ?? "");
      // setTimeCodes(foundCustomer.timeCodes);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      if (ex.response.status === 404) {
        setShowAccountNotFoundHelperText(true);
      }
      // console.log("hi inside order page");
      handleApiError(ex, history);
    }
  };
  const [customerToShow, setCustomerToShow] = useState();
  const [showCustomerByAccount, setShowCustomerByAccount] = useState(false);
  const lookupAccount = () => {
    setShowCustomerByAccount(true);
    setCustomerToShow(customersWithAccountNumbers[accountNumberToLookup]);
  };
  function parseCityAndState(item) {
    let response = item.map((i) => i.city + "," + i.state);
    return response;
  }
  const handleSetCityAndState = (e) => {};
  const [cityandStateArray, setCityAndStateArray] = useState([]);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        var cityState = cityAndState.split(",");
        // console.log(cityState[0]);
        setCustomerCity([cityState[0]]);
        setCustomerState([cityState[1]]);
        // console.log("test for console");

        const cityAndStateData = await axios.get(
          `${apiUrl}Customer/GetCustomersForCityAndState/?city=${String(
            cityState[0]
          )}&state=${String(cityState[1])}`
        );
        // console.log(cityAndStateData);

        setCustomerInfo(cityAndStateData);
        // console.log("just an index");

        // console.log(customerInfo);
      } catch (ex) {
        handleApiError(ex, history);
      } finally {
        setLoading(false);
      }
    })();
  }, [cityAndState, history]);

  // console.log(customerSelectionType);
  // console.log(customerSelectionTypes);
  const [clientJWTInfo, setClientJWTInfo] = useState();
  // console.log(customerSelectionType);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const tokenInfo = jwtDecode(localStorage.getItem(tokenKeyName));
        tokenInfo.CustomerByAccountClient
          ? setCustomerSelectionType(customerSelectionTypes.account)
          : setCustomerSelectionType(customerSelectionTypes.existing);
        setClientJWTInfo(tokenInfo);
        const profileResponse = await getProfileInformation();
        setEmailAddress(profileResponse.data.userEmailAddresses.split(";")[0]);
        const response = await axios.get(`${apiUrl}/Customer/GetCityAndStates`);
        // console.log("setting counter");

        let cityAndStateResponseData = parseCityAndState(response.data);
        setCityAndStateArray(cityAndStateResponseData);
      } catch (ex) {
        handleApiError(ex, history);
      } finally {
        setLoading(false);
      }
    })();
  }, [history]);

  const [customersWithAccountNumbers, setCustomersWithAccountNumbers] =
    useState({
      1: {
        name: "California Mechanic with an account TM",
        address: "LA",
        email: "wechargeperminuteforparking@california.gov",
        phone: "915-555-5555",
      },
      2: {
        name: "We Killed the Dragon Car Rentals",
        address: "Lumby",
        email: "chosenonescape@rsprivateservers.com",
        phone: "925-555-5555",
      },
      3: {
        name: "__f0rtnitepro___52",
        address: "Tencent HQ",
        email: "contact@epicgames.com",
        phone: "935-555-5555",
      },
    });

  const handleChangeSetComments = (e) => {
    setComments(e.target.value);
  };
  const handleChangeManualCity = (e) => {
    setManualCity(e.target.value);
  };

  const [citiesForState, setCitiesForState] = useState([]);
  const handleChangeManualState = async (e) => {
    setManualCity("");
    setManualState(e.target.value);
    setLoading(true);
    try {
      const citiesForStateResponse = await getCitiesForState(e.target.value);
      const citiesAvailableToClient = citiesForStateResponse.data.clientCity;
      setCitiesForState(citiesAvailableToClient);
    } catch (ex) {
      handleApiError(ex, history);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCustomerName = (e) => {
    setCustomerName(e.target.value);
  };
  const handleChangeCustomerAddress = (e) => {
    setCustomerAddress(e.target.value);
  };

  const [comments, setComments] = useState("");
  const [orderInfo, setOrderInfo] = useState({ comments: "" });
  const [pieceType, setPieceType] = useState("");
  const [contactName, setContactName] = useState("");
  const handleChangeOrderInfo = (e) => {
    const { name, value } = e.target;
    setOrderInfo({ ...orderInfo, [name]: value });
  };
  const handleChangeCustomerCity = (e) => {
    setCustomerCity(e.target.value);
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);

  //   let orderRequest = {};

  //   const orderRequestBase = {
  //     pieceCount: commonOrderFormValues.pieceCount,
  //     comment: commonOrderFormValues.comment,
  //     timeCode: customerSelectionFormValues.timeCode,
  //     weight: commonOrderFormValues.weight,
  //     pieceType: commonOrderFormValues.pieceType
  //       ? commonOrderFormValues.pieceType.trim()
  //       : "",
  //     callTag: formValues.callTag,
  //     contactName: formValues.contactName,
  //     contactPhone: formValues.contactPhone,
  //     emailAddress: formValues.emailAddress,
  //   };

  //   if (customerSelectionFormValues.customerSelectionType === "account") {
  //     const customerAccountBase = {
  //       customerAccountId: customerAccountId,
  //     };

  //     orderRequest = { ...orderRequestBase, ...customerAccountBase };
  //   } else if (customerSelectionFormValues.customerSelectionType === "manual") {
  //     const manualCustomerBase = {
  //       customerName: manualCustomerFormValues.customerName,
  //       customerAddress: manualCustomerFormValues.customerAddress,
  //       customerCity: manualCustomerFormValues.customerCity,
  //       customerStateAbbreviation:
  //         manualCustomerFormValues.customerStateAbbreviation,
  //       customerZipCode: manualCustomerFormValues.customerZipCode,
  //       customerPhoneNumber: manualCustomerFormValues.customerPhoneNumber,
  //     };

  //     orderRequest = { ...orderRequestBase, ...manualCustomerBase };
  //   } else {
  //     const normalCustomerBase = {
  //       customerId: customerId,
  //     };

  //     orderRequest = { ...orderRequestBase, ...normalCustomerBase };
  //   }

  //   try {
  //     const { data: response } = await postBuyout(orderRequest);

  //     toast.success("Order has been posted.");

  //     const redirectUrl = generatePath("/view-labels/:id", {
  //       id: response.deliveryId,
  //     });

  //     window.open(redirectUrl, "_blank");

  //     setLoading(false);
  //   } catch (ex) {
  //     setLoading(false);
  //     handleApiError(ex, history);
  //   }
  // };
  //==============================Invoice List Section ==================================//
  const [valuationRate, setValuationRate] = useState(0.006); //*******REPLACE THIS WITH VALUE RECEIVED FROM BACKEND - MAKE SURE TO ADJUST FOR DECIMAL PLACES - IT IS SUPPOSED TO BE .6% in the end!!!!!************
  const [foundAccountCustomer, setFoundAccountCustomer] = useState(null);
  const [showAccountNotFoundHelperText, setShowAccountNotFoundHelperText] =
    useState(false);
  const [manualEntryCity, setManualEntryCity] = useState();
  const [invoices, setInvoices] = useState([{ ...InvoiceTemplate }]);
  const handleChangeContactName = (e) => {
    setContactName(e.target.value);
  };
  const handleChangeInvoiceNumber = (e, invoiceIndex) => {
    let updatedInvoices = [...invoices];

    updatedInvoices[invoiceIndex].invoiceNumber = e.target.value;
    setInvoices(updatedInvoices);
  };
  const handleChangePhoneNumber = (e) => {
    setCustomerPhoneNumber(e.target.value);
  };
  const handleSelectCityAndState = (e) => {
    setCustomer(""); //when we change city/state, reset customer to blank
    setCustomerIndex();

    setCityAndState(e.target.value);
  };

  const [customerIndex, setCustomerIndex] = useState(); //index
  const [timeCodes, setTimeCodes] = useState([]);
  const [customerState, setCustomerState] = useState([]);
  const [customerComboboxSearchTerm, setCustomerComboboxSearchTerm] =
    useState("");

  const handleClearCurrentValue = () => {
    setCustomerIndex();
  };

  const customerOptions = useMemo(() => {
    return (
      customerInfo.data?.map((customer, index) => {
        return {
          display:
            customer.customerName?.trim() +
            " - " +
            customer.customerAddress.trim(),
          value: "" + index, //this is to fix issue if the you do 0 && <Component/> it displays the 0
        };
      }) ?? []
    );
  }, [customerInfo.data]);
  // console.log(customerInfo);
  // console.log(customerOptions);

  const handleSelectCustomerOption = async (display, selectedCustomerIndex) => {
    setCustomerComboboxSearchTerm(display);
    setCustomerIndex(selectedCustomerIndex);
    setTimeCodes([]);
    setTimeCode("");
    // console.log("handle select customer option");
    // console.log(selectedCustomerIndex);
    if (selectedCustomerIndex === null || selectedCustomerIndex === undefined) {
      // console.log("entered !selectedCustomerIndex");
      //if selectedCustomerIndex is blank (i.e. they selected "Select Customer")
      setCustomerId(); //reinitialize, but doesn't seem to be necessary as they cannot continue with the form until reselecting a customer
      setCustomerName(""); //not sure if dealing with this state variable is necessary here
      return; //do not continue
    }
    const selectedCustomer = customerInfo.data[selectedCustomerIndex];
    // console.log("selected customer", selectedCustomer);
    setCustomerId(selectedCustomer.customerId);
    setCustomerName(selectedCustomer.customerName); //not sure if this is necessary as I think the backend just looks at the customerId if selecting an existing customer. I believe this state variable is used for the manual entry input value during manual/new customer entry.
    setLoading(true);
    try {
      // console.log(selectedCustomer);
      const timeCodeResponse = await getTimeCodesForCityAndStateAndZip(
        selectedCustomer.customerCity,
        selectedCustomer.customerState,
        selectedCustomer.customerZip.substring(0, 5)
      );
      setTimeCodes(timeCodeResponse.data);
      setTimeCode("");
    } catch (ex) {
      handleApiError(ex, history);
    } finally {
      setLoading(false);
    }
    //let index = customerInfo.map((item) => item.id).indexOf(customerIndex);
    //console.log(index);
    //   console.log(customerIndex);
    // customerInfo[e.target.value].customerName;
    //set the customer index to 0, as we moved the selected customer to that index, it will always be 0 but we set it to 0 here because if they select "Select Customer" we set it to "" (maybe we can omit that later)
  };

  const handleChangeCustomerSelectionType = (e) => {
    // console.log(e.target.value);
    setCustomerSelectionType(e.target.value);
    setCustomerIndex();
    setCustomerName("");
    setCustomerAddress("");
    setManualCity("");
    setManualState("");
    setCustomerZipCode("");
    setCustomerPhoneNumber("");
    setCityAndState("");
    setFoundAccountCustomer(null);
    setAccountNumberToLookup("");
    setCustomer("");
    setTimeCode("");
    setTimeCodes([]);
  };
  const NewBuyoutCustomerDisplay = ({
    name,
    address,
    city,
    state,
    zip,
    email,
    phone,
  }) => {
    return (
      <address
        className="text-left m-md-auto p-2"
        style={{ width: "fit-content" }}
      >
        <h4>{name}</h4>
        <p className="m-1">{address}</p>
        <p className="m-1">{city + ", " + state + " " + zip}</p>
        {/* don't get it from the back end right now but added it anyway. */}
        {phone && <p className="m-1">{phone}</p>}
        {/* Do not get these from backend right now, not even sure we really store it */}
        {/* <p className="m-1">
      {email} 
    </p>
    <p className="m-1">
      {phone}
    </p> */}
      </address>
    );
  };
  const [customerContactName, setCustomerContactName] = useState([]);
  const handleChangeCustomerState = async (e) => {
    setCustomerState(e.target.value);
  };
  const handleSetCustomerContactName = async (e) => {
    try {
      setCustomerContactName(e.target.vaule);
    } catch (ex) {}
  };

  const fetchTimeCodesForCityAndStateAndZip = async (
    city,
    state,
    zip,
    signal
  ) => {
    try {
      // var cityState = cityAndState.split(",");
      // if (cityState[0] != null && cityState[0] != "") {
      //   const { data: receivedTimeCodes } = await http.get(
      //     `${apiUrl}Customer/GetTimeCodesForCityAndState?city=${cityState[0]}&state=${cityState[1]}`,
      //     { signal: signal }
      //   );

      //   setTimeCodes(receivedTimeCodes);
      // }
      // if (manualCity != null && manualCity != "") {
      //   // console.log("made itaskjdfklajsdkfjl");
      //   const { data: receivedTimeCodes } = await http.get(
      //     `${apiUrl}Customer/GetTimeCodesForCityAndState?city=${manualCity}&state=${manualState}`,
      //     { signal: signal }
      //   );
      //   // console.log(receivedTimeCodes);
      //   // console.log(manualCity);
      //   // console.log(manualState);
      //   setTimeCodes(receivedTimeCodes);
      // }

      //reset timecode and time codes while we fetch new options
      setTimeCodes([]);
      setTimeCode("");
      const { data: receivedTimeCodes } =
        await getTimeCodesForCityAndStateAndZip(
          city,
          state,
          zip.substring(0, 5),
          signal
        );
      setTimeCodes(receivedTimeCodes);
      setIsFetchingTimeCodes(false);
      if (timeCodesError) {
        setTimeCodesError(false);
      }
    } catch (ex) {
      if (ex?.name !== "CanceledError") {
        setIsFetchingTimeCodes(false);
        handleApiError(ex, history);
        setTimeCodesError(true);
      }
    }
  };
  const debounceFetchTimeCodesForCityAndState = useCallback(
    debounce(fetchTimeCodesForCityAndStateAndZip, 500),

    [cityAndState, manualCity, manualState]
  );
  const handleSelectTimeCode = (e) => {
    setTimeCode(e.target.value);
  };
  const [isFetchingTimeCodes, setIsFetchingTimeCodes] = useState(false);
  const [timeCodesError, setTimeCodesError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      // {
      //   var cityState = cityAndState.split(",");
      // }
      setTimeCodes([]);
      //getting time codes for manual customer selection is done here
      //for existing customers, we do it in handleSelectCustomer
      //for customers by account, we do it in the handleClickFindAccount function

      //manual
      // console.log(manualCity);
      // console.log(manualState);
      // console.log(customerZipCode);
      if (
        manualCity != "" &&
        manualCity != null &&
        manualState != "" &&
        manualState != null &&
        customerZipCode?.length >= 5
      ) {
        try {
          setIsFetchingTimeCodes(true);
          debounceFetchTimeCodesForCityAndState(
            manualCity,
            manualState,
            customerZipCode,
            controller.signal
          );
        } catch (ex) {
          setIsFetchingTimeCodes(false);
          handleApiError(ex, history);
        }
      } else {
        if (isFetchingTimeCodes) {
          setIsFetchingTimeCodes(false);
          controller.abort();
        }
      }
    })();
    return () => {
      controller.abort();
    };
  }, [manualCity, manualState, customerZipCode, history]);

  return (
    <>
      <Helmet>
        <title>New Buyout - {defaultTitle} </title>
      </Helmet>
      {localStorage.getItem("postOrderLabelPrintMethod") ===
        postOrderLabelPrintMethods.directToPrint && (
        <AutoInitiatePrint src={labelSrc} id="labelpdf" />
      )}
      <LabelViewerModal
        show={labelViewerModalData.show}
        onHide={handleHideLabelViewerModal}
        deliveryId={labelViewerModalData.deliveryId}
      />
      <form
        onInvalid={handleOnInvalid}
        onSubmit={handleOnSubmit}
        onKeyPress={(e) => {
          //prevents enter from submitting the form while still allowing user to do a carriage return in text areas (shift + enter). It does still disable carriage returns with just enter in text areas unfortunately
          e.key === "Enter" && e.shiftKey === false && e.preventDefault();
        }}
      >
        <div className="container paper-panel form-container">
          {/* ****MAKE MODAL FOR INVOICE LIST DELETION */}
          <div className="row">
            <div className="col form-header">
              <h1>New Buyout </h1>
              <p>
                <span className="required-star">*</span> denotes a required
                field.
              </p>
            </div>
          </div>
          <div className="container paper-panel sub-panel">
            <div className="row sub-panel-header align-items-center">
              <div className="col-6">Customer Selection</div>
              <div className="col-6 justify-content-end d-flex">
                <DiliTextCP
                  type="select"
                  wasSubmitted={wasSubmitted}
                  successfulSubmissionNotif={wasValue}
                  className="form-group"
                  name="customerSelectionType"
                  style={{ maxWidth: "fit-content", textOverflow: "ellipsis" }}
                  value={customerSelectionType}
                  onChange={handleChangeCustomerSelectionType}
                >
                  {jwtToken.CustomerByAccountClient && (
                    <option value={customerSelectionTypes.account}>
                      Account Number
                    </option>
                  )}
                  <option value={customerSelectionTypes.existing}>
                    Customer List
                  </option>
                  <option value={customerSelectionTypes.new}>
                    Manual Entry
                  </option>
                </DiliTextCP>
              </div>
            </div>
            {customerSelectionType === customerSelectionTypes.existing ? (
              <div className="row p-2">
                <div className="col-md-6">
                  <div className="form-group">
                    <DiliTextCP
                      key="City & State" //not sure but without this, upon finding an account in customer by account selection, and then switching to existing customer selection, this field would be marked red
                      label="City & State"
                      className="form-group"
                      invalidText="Please select a city & state"
                      type="select"
                      required
                      wasSubmitted={existingSubmit}
                      successfulSubmissionNotif={wasValue}
                      name="cityAndState"
                      value={cityAndState}
                      onChange={handleSelectCityAndState}
                      style={{
                        maxWidth: "fit-content",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <option value="">Select City</option>
                      {cityandStateArray?.map((cityAndState, index) => {
                        return (
                          <option
                            key={index + "-" + cityAndState}
                            value={cityAndState}
                          >
                            {cityAndState.split(",")[0] +
                              ", " +
                              cityAndState.split(",")[1]}
                          </option>
                        );
                      })}
                    </DiliTextCP>
                  </div>
                  <div className="form-group">
                    {/* <DiliTextCP
                      required
                      label="Customer"
                      invalidText="Please select a customer"
                      type="select"
                      wasSubmitted={existingSubmit}
                      className="form-group"
                      successfulSubmissionNotif={wasValue}
                      name="customer"
                      style={{ textOverflow: "ellipsis" }}
                      disabled={cityAndState === ""}
                      value={customerIndex}
                      onChange={handleSelectCustomer}
                    >
                      <option value="">Select Customer</option>
                      {cityAndState &&
                        customerInfo.data?.map((customer, index) => {
                          return (
                            <option
                              key={
                                customer.customerId +
                                "-" +
                                customer.customerName
                              }
                              value={index}
                            >
                              {customer.customerName} -{" "}
                              {customer.customerAddress}
                            </option>
                          );
                        })}
                    </DiliTextCP> */}
                    <ComboboxInfiniteLoading
                      label="Customer"
                      required
                      validate
                      placeholder="Select Customer"
                      options={customerOptions}
                      currentSearchTerm={customerComboboxSearchTerm}
                      setCurrentSearchTerm={setCustomerComboboxSearchTerm}
                      currentValue={customerIndex}
                      onClearCurrentSearchTerm={handleClearCurrentValue}
                      selectFromOptionsOnly
                      onSelectOption={handleSelectCustomerOption}
                      comboboxBackgroundColor="white"
                      comboboxBorderRadius=".25rem"
                      // autofilter={false}
                      autofilterTrim={true}
                      freesolo={false}
                      infiniteLoading
                      infiniteLoadingOptions={{
                        initialResultsCount: 500,
                        resultsAmountIncrement: 500,
                      }}
                      optionsContainerBackgroundColor="rgb(255,255,255)"
                      removeBorderBottom
                      clearSearchTermOnOptionsChange
                      showDropdownArrow
                      noResultsMessage={
                        customerComboboxSearchTerm || cityAndState
                          ? "No Customers Found"
                          : "Please select a city and state to view customers for that location."
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 ">
                  {customerIndex >= 0 && (
                    <NewBuyoutCustomerDisplay
                      name={customerInfo.data[customerIndex].customerName}
                      address={customerInfo.data[customerIndex].customerAddress}
                      city={customerInfo.data[customerIndex].customerCity}
                      state={customerInfo.data[customerIndex].customerState}
                      zip={customerInfo.data[customerIndex].customerZip}
                    />
                  )}
                </div>
              </div>
            ) : customerSelectionType === customerSelectionTypes.account ? (
              <div className="row p-2">
                <div className="col-md-6">
                  <div className="form-group">
                    <DiliTextCP
                      key="Account Number"
                      label="Account Number"
                      invalidText="Please select an account number"
                      required
                      wasSubmitted={lookupSubmit}
                      successfulSubmissionNotif={wasValue}
                      value={accountNumberToLookup}
                      onChange={handleChangeAccountNumber}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          handleClickFindAccount();
                        }
                      }}
                      type="text"
                      className="form-group"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={handleClickFindAccount}
                    className="btn btn-primary"
                  >
                    Find Account
                  </button>
                </div>
                <div className="col-md-6">
                  {foundAccountCustomer && (
                    <NewOrderCustomerDisplay
                      name={foundAccountCustomer?.customerName}
                      address={foundAccountCustomer?.customerAddress}
                      city={foundAccountCustomer?.customerCity}
                      state={foundAccountCustomer?.customerState}
                      zip={foundAccountCustomer?.customerZip}
                    />
                  )}
                </div>
                <div className="col-md-6">
                  {showCustomerByAccount &&
                    (customerToShow ? (
                      <address
                        className="text-left m-md-auto p-md-2 py-4"
                        style={{ width: "fit-content" }} //*** NEED TO WORK ON THIS STYLING, MESS WITH WITH IT WHILE ADJUSTING SCREEN SIZE AND I'LL REMEMBER WHY (Want left aligned text but towards the right of the row, without it any magic numbers hard coded..., don't know if possible)
                      >
                        <h3>{customerToShow.name}</h3>

                        <p className="m-1">{customerToShow.address}</p>
                        <p className="m-1">{customerToShow.email}</p>
                        <p className="m-1">{customerToShow.phone}</p>
                      </address>
                    ) : (
                      <div>&nbsp; No account found</div>
                    ))}
                </div>
              </div>
            ) : (
              <div className="row p-2">
                <div className="form-group col-md-6 col-lg-4">
                  <DiliTextCP
                    invalidText="Please enter customer's name."
                    name="customerName"
                    required
                    label="Customer Name"
                    wasSubmitted={manualSubmit}
                    value={customerName}
                    onChange={handleChangeCustomerName}
                    successfulSubmissionNotif={wasValue}
                    maxLength="50"
                    className="form-group"
                  />
                </div>
                <div className="form-group col-md-6 col-lg-4">
                  <DiliTextCP
                    required
                    label="Customer Address"
                    invalidText="Please enter customer's address."
                    successfulSubmissionNotif={wasValue}
                    wasSubmitted={manualSubmit}
                    value={customerAddress}
                    onChange={handleChangeCustomerAddress}
                    name="customerAddress"
                    maxLength="50"
                    className="form-group"
                  />
                </div>
                <div className="form-group col-md-6 col-lg-4">
                  <DiliTextCP
                    label="Customer Phone"
                    value={customerPhoneNumber}
                    onChange={handleChangePhoneNumber}
                    name="customerPhoneNumber"
                    type="tel"
                    maxLength="12"
                    className="form-group"
                  />
                </div>
                <div className="form-group col-md-6 col-lg-4">
                  <DiliTextCP
                    required
                    type="select"
                    label="Customer State"
                    invalidText="Please select the state your customer is located."
                    wasSubmitted={manualSubmit}
                    name="customerStateAbbreviation"
                    value={manualState}
                    onChange={handleChangeManualState}
                    successfulSubmissionNotif={wasValue}
                    className="form-group"
                  >
                    <option value="">Select State</option>
                    <option value="AL">AL</option>
                    <option value="AK">AK</option>
                    <option value="AZ">AZ</option>
                    <option value="AR">AR</option>
                    <option value="CA">CA</option>
                    <option value="CO">CO</option>
                    <option value="CT">CT</option>
                    <option value="DE">DE</option>
                    <option value="FL">FL</option>
                    <option value="GA">GA</option>
                    <option value="HI">HI</option>
                    <option value="ID">ID</option>
                    <option value="IL">IL</option>
                    <option value="IN">IN</option>
                    <option value="IA">IA</option>
                    <option value="KS">KS</option>
                    <option value="KY">KY</option>
                    <option value="LA">LA</option>
                    <option value="ME">ME</option>
                    <option value="MD">MD</option>
                    <option value="MA">MA</option>
                    <option value="MI">MI</option>
                    <option value="MN">MN</option>
                    <option value="MS">MS</option>
                    <option value="MO">MO</option>
                    <option value="MT">MT</option>
                    <option value="NE">NE</option>
                    <option value="NV">NV</option>
                    <option value="NH">NH</option>
                    <option value="NJ">NJ</option>
                    <option value="NM">NM</option>
                    <option value="NY">NY</option>
                    <option value="NC">NC</option>
                    <option value="ND">ND</option>
                    <option value="OH">OH</option>
                    <option value="OK">OK</option>
                    <option value="OR">OR</option>
                    <option value="PA">PA</option>
                    <option value="RI">RI</option>
                    <option value="SC">SC</option>
                    <option value="SD">SD</option>
                    <option value="TN">TN</option>
                    <option value="TX">TX</option>
                    <option value="UT">UT</option>
                    <option value="VT">VT</option>
                    <option value="VA">VA</option>
                    <option value="WA">WA</option>
                    <option value="WV">WV</option>
                    <option value="WI">WI</option>
                    <option value="WY">WY</option>
                  </DiliTextCP>
                </div>
                <DiliTextCP
                  className="form-group col-md-6 col-lg-4"
                  required
                  maxLength="35"
                  label="Customer City"
                  name="customerCity"
                  type="select"
                  value={manualCity}
                  onChange={handleChangeManualCity}
                  wasSubmitted={manualSubmit}
                  successfulSubmissionNotif={wasValue}
                  invalidText="Please select the city your customer is located."
                  helperText="Select a state to view cities."
                  showHelperText={manualState === ""}
                  helperTextClass="text-note"
                  //if we switch to showing them only states they have cities for/access to, this will no longer be necessary
                  problemText={
                    "No cities found for this state. Contact Diligent to inquire about city availability."
                  }
                  showProblemText={
                    manualState !== "" &&
                    citiesForState.length === 0 &&
                    !loading
                  }
                >
                  <option value="">Select City</option>
                  {citiesForState.map((city, index) => {
                    return (
                      <option value={city} key={index + "-" + city}>
                        {city}
                      </option>
                    );
                  })}
                </DiliTextCP>
                <div className="form-group col-md-6 col-lg-4">
                  <DiliTextCP
                    label="Customer Zip"
                    invalidText="Please enter customer's zip code."
                    wasSubmitted={manualSubmit}
                    successfulSubmissionNotif={wasValue}
                    value={customerZipCode}
                    onChange={handleChangeZipCode}
                    name="customerZipCode"
                    required
                    maxLength="10"
                    className="form-group"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="container paper-panel sub-panel">
            <div className="row sub-panel-header align-items-center">
              <div className="col-sm-6">Buyout Info</div>
            </div>
            <div className="row p-2">
              {/* *******remember to look at timecodeselecter.jsx - something there sometimes warns we are not able to deliver to certain combinations of city/state/timecode? */}
              <div className="col-lg-6">
                <div className="row">
                  <div className="form-group col-lg-6">
                    <DiliTextCP
                      label="Time Code"
                      invalidText="Please select a time code."
                      validationTest={(inputValue) => {
                        return inputValue.length > 0 || timeCodes.length === 0; //if value of time code input is non empty or if there are no time codes to choose from in the first place, it is valid
                      }}
                      required
                      successfulSubmissionNotif={wasValue}
                      wasSubmitted={wasSubmitted}
                      value={timeCode}
                      onChange={handleSelectTimeCode}
                      loading={isFetchingTimeCodes}
                      type="select"
                      className="form-group"
                      disabled={timeCodes.length <= 0}
                      problemText="There was an error retrieving time codes. Please refresh the page and try again."
                      showProblemText={timeCodesError}
                      helperText={
                        customerSelectionType === customerSelectionTypes.new
                          ? "Please fill out customer city, state, and zip to see time codes."
                          : customerSelectionType ===
                            customerSelectionTypes.account
                          ? "Please find a customer to see time codes."
                          : ""
                      }
                      showHelperText={
                        (customerSelectionType === customerSelectionTypes.new &&
                          (manualCity === "" ||
                            manualState === "" ||
                            customerZipCode.length < 5)) ||
                        (customerSelectionType ===
                          customerSelectionTypes.account &&
                          !foundAccountCustomer?.customerAccountId)
                      }
                      helperTextClass="text-note"
                    >
                      <option value="">Select Time Code</option>
                      {timeCodes.length > 0 &&
                        timeCodes.map((e) => {
                          return (
                            <option key={e} value={e}>
                              {e + " (" + getTimeCodeMeaning(e) + ")"}
                            </option>
                          );
                        })}
                      {/* <option>NN (Noon)</option>
                    <option>NT (Night)</option>
                    <option>ND (Next Day)</option> */}
                    </DiliTextCP>
                  </div>
                  <div className="form-group col-lg-6">
                    <DiliTextCP
                      label="Call Tag"
                      maxLength={15}
                      type="text"
                      name="callTag"
                      value={callTag}
                      wasSubmitted={wasSubmitted}
                      onChange={handleChangeCallTag}
                      successfulSubmissionNotif={wasValue}
                      className="form-group"
                      inputStyle={{ textOverflow: "ellipsis" }}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <DiliTextCP
                      required
                      label="Email Address"
                      maxLength={50}
                      type="text"
                      wasSubmitted={wasSubmitted}
                      successfulSubmissionNotif={wasValue}
                      value={emailAddress}
                      onChange={handleChangeEmailAddress}
                      invalidText="Please enter  email address."
                      name="codType"
                      validationTest={(item) => isValidEmail(item)}
                      className="form-group"
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label> Contact Phone </label>
                    <DiliTextCP
                      value={contactPhone}
                      onChange={handleChangeContactPhone}
                      type="tel"
                      maxLength="12"
                      name="codType"
                      wasSubmitted={wasSubmitted}
                      successfulSubmissionNotif={wasValue}
                      // disabled={invoices[0].declaredValue <= 0}
                      className="form-group"
                    />
                    {/* *** WHERE THERE ANY OTHER OPTIONS? DOUBLE CHECK */}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-12 col-xl-6">
                    <label
                      className={
                        (!pieceCount && wasSubmitted) ||
                        (!pieceCount && startedTypingPC)
                          ? "text-danger"
                          : ""
                      }
                    >
                      Piece Count<span className="required-star">*</span>
                    </label>
                    <div className="form-row">
                      <div className="col-4">
                        <DiliTextCP
                          min="1"
                          type="number"
                          max="99"
                          invalidText="Please select piece count"
                          successfulSubmissionNotif={wasValue}
                          wasSubmitted={wasSubmitted}
                          // maxWidth={150}
                          required
                          value={pieceCount}
                          onChange={handleChangePieceCount}
                          className="form-group"
                        />
                      </div>

                      <div className="col">
                        <DiliTextCP
                          // required
                          wasSubmitted={wasSubmitted}
                          successfulSubmissionNotif={wasValue}
                          type="select"
                          value={pieceType}
                          onChange={handleChangePieceType}
                          className="form-group"
                        >
                          <option value="">Piece</option>
                          <option value="S">Pallet</option>
                          <option value="E">Engine</option>
                          <option value="M">Transmission</option>
                          <option value="O">Oversized</option>
                          <option value="P">Parcel</option>
                        </DiliTextCP>
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-xl-6">
                    <div>
                      <label>Weight</label>
                      <div className="input-group">
                        <NumberInput
                          name="weight"
                          type="number"
                          max="10000"
                          min="0"
                          integerOnly
                          positiveOnly
                          blockScientificNotation
                          className="form-control"
                          value={weight}
                          onChange={handleChangeWeight}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">lbs.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row justify-content-end">
                  <div className="form-group col-xl-8">
                    <label>Customer Contact Name</label>
                    <DiliTextCP
                      value={contactName}
                      maxLength={25}
                      onChange={handleChangeContactName}
                      name="refNo"
                      type="text"
                      className="form-group"
                    />
                  </div>
                  <div className="form-group col-xl-8">
                    <label>Comments</label>
                    <textarea
                      className="textarea-comments form-control"
                      type="text"
                      maxLength="500"
                      // wasSubmitted={wasSubmitted} //this is not for a built in textarea.
                      // successfulSubmissionNotif={wasValue}
                      value={comments}
                      onChange={handleChangeSetComments}
                    />
                    <div className="textarea-charactercount">
                      {comments.length}/500
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            By submitting your order, you agree to our{" "}
            <a target="_blank" href="/pdfs/Network Terms and Conditions.pdf">
              terms and conditions
            </a>
            .
          </p>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default PostNewBuyoutV2;
